export const REQUEST_LANGUAGES = 'list-languages';
export const LANGUAGES_LOADED = 'loaded-languages';
export const UPDATE_LANGUAGE = 'update-language';
export const UPDATED_LANGUAGE = 'updated-language';
export const SEARCH_REQUEST_LANGUAGES = 'search-languages';
export const DELETE_LANGUAGE = 'delete-language';
export const DELETED_LANGUAGE = 'deleted-language';

export function requestLanguages(payload) {
    return {
        type: REQUEST_LANGUAGES,
        data: payload
    }
}
export function loadedLanguages(payload) {
    return {
        type: LANGUAGES_LOADED,
        payload: payload
    };
}

export function updateLanguage(payload) {
    return {
        type: UPDATE_LANGUAGE,
        id: payload.id,
        data: payload
    };
}

export function updatedLanguage() {
    return {
        type: UPDATED_LANGUAGE
    };
}

export function searchLanguages(payload) {
    return {
        type: SEARCH_REQUEST_LANGUAGES,
        data: payload
    }
}

export function deleteLanguage(payload) {
    return {
        type: DELETE_LANGUAGE,
        data: payload
    }
}

export function deletedLanguage() {
    return {
      type: DELETED_LANGUAGE
    };
}


// WEBPACK FOOTER //
// ./src/actions/languages.action.js